module.exports = __webpack_public_path__ + "static/media/hiw4blue.fd252c61.svg";